<!--
    描述：快捷菜单子菜单--- 合作单位
    时间：2021-03-26
    Created by 王帅
    Edit by zl
-->
<template>
	<div class="h100">
		<w-split v-model="splitValueL">
			<div slot="left"
				 class="left pdt30">
				<div class="left-text overflow-hidden">
					<div class="text-overflow">合作单位</div>
				</div>
				<div class="w-page-container">
					<el-tree :data="baseData"
							 :props="defaultProps"
							 :highlight-current='true'
							 :default-expand-all="true"
							 ref="treeList"
							 node-key='id'
							 :default-expanded-keys='[0]'
							 @node-click="handleNodeClick">
						<div slot-scope="{ node, data }"
							 class="tree-style">
							<i v-if="data.id == '0'"
							   class="el-icon-folder-opened"
							   :class="{ white: selectId == '0' }"></i>
							<i v-else
							   class="el-icon-office-building"></i>
							{{ data.sname }}
						</div>
					</el-tree>
				</div>
			</div>
			<div slot="right"
				 class="right">
				<div class="primary-layout">
					<div class="primary-header">
						<div class="title text-overflow">
							合作单位： <span class="blue">{{ total }}</span> 家
						</div>
						<div class="btnGroups">
							<el-input placeholder="请输入单位名称（全称或简称）"
									  v-model="searchForm.sname"
									  class="mr10 w300"
									  size="small"
									  @keyup.enter.native="doSearch">
								<template slot="append">
									<el-button size="small"
											   @click="doSearch"
											   class="btn-blue padding">查询</el-button>
								</template>
							</el-input>
							<el-button type="primary"
									   class="btn-blue"
									   icon="el-icon-refresh"
									   @click="doRefresh"
									   size="small"></el-button>
						</div>
					</div>

					<div class="primary-content w-table-layout w-table-page">
						<div class="w-table-content">
							<vxe-table :data="filterData"
									   align="center"
									   auto-resize
									   border
									   size="small"
									   height="100%"
									   highlight-hover-row
									   highlight-current-row
									   show-overflow="tooltip"
									   show-header-overflow="tooltip">
								<vxe-table-column type="seq"
												  title="序号"
												  width="65"></vxe-table-column>
								<vxe-table-column field="unitName"
												  title="单位名称"
												  align="left"
												  header-align="center">
									<template #default="{ row }">
										<span class="vxe-cell--label blue-text"
											  @click="viewUnit(row)">
											{{ row.unitName }}
										</span>
									</template>
								</vxe-table-column>
								<vxe-table-column field="shortName"
												  title="企业简称"
												  width="120"
												  align="left"
												  header-align="center"></vxe-table-column>
								<vxe-table-column field="limitName"
												  title="单位类型"
												  width="120"></vxe-table-column>
								<vxe-table-column field="companyTypeName"
												  title="单位性质"
												  width="120"></vxe-table-column>
								<vxe-table-column field="address"
												  title="单位地址"
												  align="left"
												  header-align="center"></vxe-table-column>
								<vxe-table-column field="linkman"
												  title="联系人"
												  width="100"></vxe-table-column>
								<vxe-table-column field="linkPhone"
												  title="手机号"
												  width="100"></vxe-table-column>
								<vxe-table-column field="remark"
												  title="备注"
												  align="left"
												  header-align="center"></vxe-table-column>
							</vxe-table>
						</div>
						<div class="w-table-pager">
							<vxe-pager :current-page="currentPage"
									   :page-size="pageSize"
									   :total="total"
									   :layouts="[
									   'PrevJump', 
									   'PrevPage',
									   'JumpNumber',
									   'NextPage',
									   'NextJump',
									   'Sizes', 
									   'FullJump', 
									   'Total']"
									   align="center"
									   @page-change="handleCurrentChange">
							</vxe-pager>
						</div>
					</div>
				</div>

			</div>
		</w-split>
		<!-- 新增和编辑弹窗 -->
		<el-dialog :visible.sync="dialogVisible"
				   :title="dialogTitle"
				   center
				   custom-class="zbr-dialog"
				   :close-on-click-modal="false"
				   :show-close="false"
				   width="40%"
				   @close="cancel">
			<el-form v-model="unitForm"
					 label-width="160px">
				<el-row>
					<el-col :span="20"
							:offset="2">
						<el-form-item label="单位名称："
									  prop="sname">
							<el-select v-model="unitForm.sname"
									   placeholder="请选择"
									   @change="unitChange"
									   :disabled="dialogType == 'edit'">
								<el-option v-for="(item, index) in dwmc"
										   :key="'unit' + index"
										   :label="item.sname"
										   :value="item.creditCode">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="20"
							:offset="2">
						<el-form-item label="营业执照编号："
									  prop="creditCode">
							<el-input disabled
									  v-model="unitForm.creditCode">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="20"
							:offset="2">
						<el-form-item label="单位性质："
									  prop="unitNatureName">
							<el-input disabled
									  v-model="unitForm.unitNatureName">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="20"
							:offset="2">
						<el-form-item label="单位地址："
									  prop="address">
							<el-input v-model="unitForm.address"> </el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="20"
							:offset="2">
						<el-form-item label="法定代表人："
									  prop="unitLinker">
							<el-input v-model="unitForm.unitLinker"> </el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="20"
							:offset="2">
						<el-form-item label="法定代表人联系方式："
									  prop="linkPhone">
							<el-input v-model="unitForm.contract"
									  @keyup.native="unitForm.contract = unitForm.contract.replace(/[^\w+-]|_/ig,'')"
									  maxlength="12"> </el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="20"
							:offset="2">
						<el-form-item label="备注："
									  prop="remark">
							<el-input type="textarea"
									  :autosize="{ minRows: 3 }"
									  maxlength="60"
									  show-word-limit
									  v-model="unitForm.remark">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="text-align: center; margin-top:20px">
				<el-button size="medium"
						   type="plain"
						   class="btns"
						   @click="cancel">取消</el-button>
				<el-button size="medium"
						   class="btns btn-blue"
						   :type="$store.state.app.buttonsType"
						   @click="confirm">确认</el-button>
			</div>
		</el-dialog>

		<!-- 查看单位信息 -->
		<UnitContent ref="UnitContent"
					 v-if="unitShow"
					 @sendState="getState"
					 :selectCompany="unitObj"></UnitContent>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import {
	saveCoorperateUnit,
	selectPagaUnits,
	delUnit,
	getLimits,
} from 'api/unitMaintain/unit'
import UnitContent from '@/views/UnitMaintain/UnitContent'
export default {
	components: { UnitContent },
	data() {
		return {
			filterData: [], //表格数据
			unitForm: {}, //单位对象
			dialogVisible: false,
			dialogTitle: '',
			dialogType: '',
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			//左侧标签
			baseData: [
				{
					sname: '合作单位',
					id: '0',
					children: [],
				},
			],
			defaultProps: {
				children: 'children',
				label: 'sname',
				value: 'id',
			},
			limitId: '',
			dwmc: [], //单位列表
			unitType: '', //单位类型
			//筛选条件
			searchForm: {
				sname: '',
			},
			splitValueL: 0.2,
			selectId: '0',
			unitObj: {},
			unitShow: false,
		}
	},
	created() {
		getLimits().then((res) => {
			this.baseData[0].children = res.data
			this.$refs.treeList.setCurrentKey(0)
		})
		this.getData()
	},
	methods: {
		//左侧radio切换事件
		handleNodeClick(data) {
			this.selectId = data.id
			if (data.id) {
				this.limitId = data.id ? data.id : ''
				this.getData()
			}
		},

		//获得列表数据
		getData() {
			let params = Object.assign({}, this.searchForm)
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			params.limitId = this.limitId
			params.tenantId = this.tenantId
			selectPagaUnits(params)
				.then((res) => {
					this.loading = false
					this.filterData = res.data.records
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
					// 设置回显
					this.setChecked()
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 搜索
		doSearch() {
			this.currentPage = 1
			this.getData()
		},

		// 重置
		doRefresh() {
			this.searchForm.sname = ''
			this.doSearch()
		},

		//添加合作单位
		addUnit() {
			this.dialogTitle = '新增单位'
			this.dialogVisible = true
		},

		//取消
		cancel() {
			this.dialogVisible = false
			this.dialogType = ''
			this.unitForm = {
				sname: '',
				creditCode: '',
			}
		},

		//弹窗确认
		confirm() {
			this.unitForm.unitType = this.unitType
			saveCoorperateUnit(this.unitForm).then((res) => {
				this.unitForm = {
					sname: '',
				}
				this.dialogVisible = false
				this.getData()
			})
		},

		//编辑单位
		editUnit(row) {
			this.unitForm = JSON.parse(JSON.stringify(row))
			this.dialogTitle = '编辑单位'
			this.dialogVisible = true
			this.dialogType = 'edit'
		},

		//删除单位
		deleteUnit(data) {
			this.$confirm('确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				delUnit({ id: data.id }).then((d) => {
					if ((d.operationCode = 1)) {
						this.$message.success(d.msg)
					}
					this.popVisible = false
					this.searchForm = {}
					this.getData()
				})
			})
		},

		//选择器改变事件
		unitChange() {
			this.dwmc.forEach((v) => {
				if (v.creditCode == this.unitForm.sname) {
					let obj = Object.assign({}, v)
					this.unitForm = obj
					this.unitForm.companyId = v.tenantId
					this.unitForm.tenantId = this.tenantId
				}
			})
		},

		// 分页监听事件
		handleCurrentChange(data) {
			this.currentPage = data.currentPage
			this.pageSize = data.pageSize
			this.getData()
		},

		// 查看单位详情
		viewUnit(data) {
			this.unitObj = data
			this.unitShow = true
			setTimeout(() => {
				this.$refs.UnitContent.unitShow = true
			}, 200)
		},

		// 接收状态
		getState(data) {
			this.unitShow = data
		},
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('user', {
			tenantId: (state) => state.tenantId,
		}),
		routeQuery() {
			return this.$route.query.type
		},
	},
}
</script>

<style scoped lang="less">
.left,
.right {
	padding: 10px;
	height: 100%;
	background-color: #fff;
}
.padding {
	padding: 9px 20px;
}
.pdt30 {
	padding-top: 20px !important;
}
.btns {
	padding: 0 50px !important;
}
.w300 {
	/deep/.el-input__inner {
		width: 300px;
	}
}
.tree-style {
	font-size: 14px !important;
	i {
		margin-right: 5px !important;
		color: #555;
	}
}
/deep/.el-tree-node__children {
	.is-current {
		i {
			color: #fff;
		}
	}
}
.white {
	color: #fff !important;
}
</style>

